














































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import moment from "moment";
import { namespace } from 'vuex-class';
import {IUserData} from "@/models/ApiModels";
import {OTHER_ROUTES} from "@/constants/routes";
import ResendVerification from "@/views/Dialog/views/ResendVerification.vue";
import Dialog from "@/views/Dialog/Dialog.vue";
import {stripHtmlTags} from "@/helpers/stringHelpers";


const userDataModule = namespace("userData");
// Todo: on edit remeber to do sanitation for html
@Component({
  name: 'Profile',
  components: {
    Dialog,
    ResendVerification,
  },
})
export default class Profile extends Vue {
  @userDataModule.Getter('userSmsWasValidated')
  private userSmsWasValidated!: boolean;


  @userDataModule.Getter('getProfile')
  private profile!: IUserData;

  private showResendVerificationDialog: boolean = false;
  private myError: boolean = false;
  private errorMessage: string = '';
  private readonly: boolean = true;
  private isCopied: boolean = false;

  private get resendVerificationDialogIsOpen() {
    return this.showResendVerificationDialog && !this.userSmsWasValidated;
  }

  private get phoneVerified(): boolean {
    return !!this.profile.sms_verified;
  }

  private get memberSince(): string {
    const format: any = this.$t('profile.member_since_format') || 'D MMMM, YYYY';
    return moment(this.profile.created_at).format(format);
  }

  private created() {
    moment.locale(this.$i18n.locale);
  }

  private openResendDialog() {
    this.showResendVerificationDialog = true;
  }

  private backToStart() {
    this.$router.push({name: OTHER_ROUTES.HOME});
  }

  private copyDeliveryToken() {
    const deliveryTokenInput: HTMLInputElement = this.$refs.deliveryToken as HTMLInputElement;
    deliveryTokenInput.select();
    document.execCommand('copy');
    this.$uiBus.emit('genericMessage:show', this.$t('profile.deliveryCodeCopied'));
  }
}
